import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Box, Text } from "samba-ui";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import "./tooltip.css";

import {
  Banner,
  ClientName,
  FeedName,
  FeedType,
  StyledFeedDetail,
  FeedDetailContent,
  Nav,
  NavButton,
  RightNav,
  Action,
} from "./styles";
import {
  TVAdExposureIcon,
  PauseIcon,
  ResumeIcon,
  InactiveFeedIcon,
} from "../../icons";
import FeedInfo from "./FeedInfo";
import { selectProgressByReportId } from "../../selectors";
import { fetchFeed, updateFeed, FEED_NOT_FOUND } from "../../actions/feed";
import { INACTIVE, FEED_TYPE_MAPPING, ENABLE_DELIVERY_THRESHOLD_FEED_AGE } from "../../constants";
import { RESTART, PAUSE } from "../Common/ServiceStopUpdateModal";
import FeedStartStopModal from "../Common/FeedStartStopModal";
import AreYouSureModal from "../Common/AreYouSureModal";

export const SUMMARY = "summary";
export const FILES = "files";
export const CRITERIA = "criteria";

const defaultState = {
  activeTab: SUMMARY,
  show: false,
  action: null,
  isOpen: false,
};

export class FeedDetail extends Component {
  state = {
    ...defaultState,
  };

  onSubmit = this.onSubmit.bind(this);
  onSubmitDeliveryMethod = this.onSubmitDeliveryMethod.bind(this);
  componentDidMount() {
    const { feedId, fetchFeed, history } = this.props;
    fetchFeed(feedId).then((action) => {
      if (action.type === FEED_NOT_FOUND) {
        history.push("/");
      }
    });
  }

  handleChangeTab(newTab) {
    this.setState({ activeTab: newTab });
  }

  getDownloadHref(clientId) {
    const getUrl = window.location;
    let baseUrl = `${getUrl.protocol}//${getUrl.host}`;
    baseUrl = baseUrl.replace("3000", "8080");
    return `${baseUrl}/api/clients/${clientId}/credentials`;
  }

  onSubmit() {
    const { feed, updateFeed } = this.props;
    this.setState({ show: false });
    updateFeed(feed.id, { paused: !feed.paused });
  }

  onSubmitDeliveryMethod() {
    const { feed, updateFeed } = this.props;
    updateFeed(feed.id, {
      misc_json: { ...feed.misc_json, delivery: "airflow" },
    });
    this.setState({ isOpen: false });
  }

  render() {
    const { activeTab, show, isOpen } = this.state;
    const { feed, files, history, client } = this.props;

    const alreadyHasDelivery =
      feed.misc_json && feed.misc_json.delivery === "airflow";

    let feedAge = (new Date() - new Date(feed.created_at))/1000/60/60/24;

    const showDataDeliveryButton =
      !alreadyHasDelivery &&
      feedAge < ENABLE_DELIVERY_THRESHOLD_FEED_AGE &&
      client.misc_json &&
      client.misc_json.self_serve_delivery &&
      (feed.type === "content viewership" ||
         feed.type === "tivo content viewership" ||
         feed.type === "spot exposure" ||
         feed.type === "tivo spot exposure" ||
         feed.type === "demographic panel" ||
        feed.type.indexOf("x_ref") > -1);
    let deliverPath = "";

    if (
      client.delivery_integration &&
      client.delivery_integration.dest_base_url &&
      feed.name
    ) {
      const feedName = encodeURIComponent(feed.name);
      const partExprDayDst =
        client.delivery_integration.part_expr_day__dst || "yyyy=%Y/mm=%m/dd=%d";
      deliverPath = `${
        client.delivery_integration.dest_base_url
      }report=${feedName}/${partExprDayDst}`;
    }

    const sortedFiles = files.sort((a, b) => new Date(b.day) - new Date(a.day));
    if (!feed || !client) return null;
    const { paused } = feed;
    const isInactive = feed.status === INACTIVE;
    const clientIsInactive =
      client.service_stop && new Date(client.service_stop) < new Date();

    let displayText, icon;
    if (clientIsInactive) {
      displayText = "Client is inactive";
      icon = <InactiveFeedIcon width="16" height="16" />;
    } else if (isInactive) {
      displayText = "Restart delivery";
      icon = <ResumeIcon />;
    } else {
      displayText = "Pause delivery";
      icon = <PauseIcon />;
    }

    return (
      <StyledFeedDetail>
        <Banner>
          <ClientName
            onClick={() => history.push(`/clients/${feed.client_id}`)}
          >
            {feed.client_name}
          </ClientName>
          <FeedName>{feed.name}</FeedName>
          <FeedType>
            <TVAdExposureIcon />
            {FEED_TYPE_MAPPING[feed.type]} File
          </FeedType>
        </Banner>
        <FeedDetailContent>
          <Nav>
            <NavButton
              isActive={activeTab === SUMMARY}
              onClick={() => this.handleChangeTab(SUMMARY)}
            >
              Summary
            </NavButton>
            <NavButton
              isActive={activeTab === FILES}
              onClick={() => this.handleChangeTab(FILES)}
            >
              Files
            </NavButton>
            <NavButton
              isActive={activeTab === CRITERIA}
              onClick={() => this.handleChangeTab(CRITERIA)}
            >
              Criteria
            </NavButton>
          </Nav>
          <Box ml={165}>
            <FeedInfo activeTab={activeTab} files={sortedFiles} feed={feed} />
          </Box>
          <RightNav>
            <Action
              onClick={() => {
                // If the client is inactive the button should be disabled
                if (clientIsInactive) return;
                const action = isInactive ? RESTART : PAUSE;
                this.setState({ show: true, action });
              }}
              isDisabled={!!clientIsInactive}
            >
              {icon}
              {displayText}
            </Action>
            {alreadyHasDelivery && (
              <Box width="240px" marginLeft="30px">
                <Text
                  fontSize="11px"
                  fontWeight={400}
                  style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                >
                  External delivery enabled: {deliverPath}
                </Text>
              </Box>
            )}
            {showDataDeliveryButton && (
              <Box>
                <Action
                  onClick={() => {
                    // If the client is inactive the button should be disabled
                    if (clientIsInactive) return;
                    this.setState({ isOpen: true });
                  }}
                  isDisabled={!!clientIsInactive}
                >
                  Push data to external partner location
                  {deliverPath && (
                    <span style={{ marginLeft: "4px" }}>
                      <Tooltip
                        title={deliverPath}
                        position="left"
                        trigger="mouseenter"
                        arrow={true}
                      >
                        <i className="fa fa-info-circle" />
                      </Tooltip>
                    </span>
                  )}
                </Action>
              </Box>
            )}
            <Box pt={2} pl={24} borderBottom={"2px solid #e3e3f2"} />
          </RightNav>
        </FeedDetailContent>
        <FeedStartStopModal
          paused={paused}
          onClose={() => this.setState({ show: false })}
          isOpen={show}
          onSubmit={this.onSubmit}
        />
        <AreYouSureModal
          isOpen={isOpen}
          onClose={() => this.setState({ isOpen: false })}
          title={"Deliver data to external partner"}
          body={`Are you sure you want update the delivery method for this feed`}
          onSubmit={this.onSubmitDeliveryMethod}
        />
      </StyledFeedDetail>
    );
  }
}

FeedDetail.propTypes = {
  feedId: PropTypes.string,
  feed: PropTypes.shape({
    id: PropTypes.number,
    client_id: PropTypes.number,
    created_at: PropTypes.string,
    delivery_schedule: PropTypes.string,
    kantar_filter_expression: PropTypes.shape({
      brand: PropTypes.arrayOf(PropTypes.string),
    }),
    name: PropTypes.string,
    pdp_infomediary: PropTypes.string,
    progress_ids: PropTypes.arrayOf(PropTypes.string),
    quality_metrics: PropTypes.shape({
      final_rowcount: PropTypes.number,
    }),
    service_start: PropTypes.string,
    status: PropTypes.string,
    updated_at: PropTypes.string,
  }),
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      day: PropTypes.string,
      report_id: PropTypes.number,
      progressing: PropTypes.bool,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
      row_cnt: PropTypes.string,
      device_cnt: PropTypes.string,
      network_cnt: PropTypes.string,
      airing_cnt: PropTypes.string,
      brand_cnt: PropTypes.string,
      sla_violation: PropTypes.bool,
    })
  ),
  fetchFeed: PropTypes.func,
  updateFeed: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  client: PropTypes.shape({
    service_stop: PropTypes.string,
  }),
};

export default withRouter(
  connect(
    (store, props) => {
      const feedId = props.match.params.feedId;
      const feed = store.entities.feeds.byId[feedId];
      const client = store.entities.clients.byId[feed && feed.client_id];
      return {
        feedId,
        feed,
        files: selectProgressByReportId(store, parseInt(feedId)),
        client,
      };
    },
    { fetchFeed, updateFeed }
  )(FeedDetail)
);
